export const StylingUserCalendarInitialState = {
    stylingcalendar: {
        items: []
    }
};
